import axios from '@axios'

export default {
  getStatus() {
    return axios.get('auth/2fa/status')
  },
  setup() {
    return axios.post('auth/2fa/setup')
  },
  setupWithToken(twoFaToken, accountType) {
    return axios.post('auth/2fa/setup-with-token', { twoFaToken, accountType })
  },
  enable(otp) {
    return axios.post('auth/2fa/enable', { otp })
  },
  enableWithToken(twoFaToken, accountType, otp) {
    return axios.post('auth/2fa/enable-with-token', { twoFaToken, accountType, otp })
  },
  disable(otp) {
    return axios.post('auth/2fa/disable', { otp })
  },
  regenerateRecoveryCodes() {
    return axios.post('auth/2fa/recovery/regenerate')
  },
  manageList(accountType, q) {
    return axios.get('auth/2fa/manage', { params: { accountType, q } })
  },
  manageReset(accountType, id) {
    return axios.post('auth/2fa/manage/reset', { accountType, id })
  },
  manageUnlock(accountType, id) {
    return axios.post('auth/2fa/manage/unlock', { accountType, id })
  },
  manageAllowSetup(accountType, id, allowed = true) {
    return axios.post('auth/2fa/manage/allow-setup', { accountType, id, allowed })
  },
}
